<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { DialogTitle, type DialogTitleProps, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/shared/lib/misc';

const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DialogTitle
    v-bind="forwardedProps"
    :class="cn('text-lg font-medium leading-none tracking-tight', props.class)"
  >
    <slot />
  </DialogTitle>
</template>
